import {GalleryNavigationLocation, GalleryNavigationPosition, GalleryNavigationType} from '../productPage/constants';
import {IProductPageSettings, ProductPageAppProps} from '../productPage/types/app-types';
import stylesParams from '../components/ProductPage/stylesParams';

export function getProductPageSettingsFromProps({globals: {styles}}: ProductPageAppProps): IProductPageSettings {
  const navigationPositionString = styles.get(stylesParams.productPage_galleryNavigationPosition).value;
  const navigationTypeString = styles.get(stylesParams.productPage_galleryNavigationType).value;
  const navigationLocationString = styles.get(stylesParams.productPage_galleryNavigationLocation).value;
  const imageMode = styles.get(stylesParams.productPage_galleryImageMode);
  const imageRatioId = styles.get(stylesParams.productPage_galleryImageRatio);
  const infoSectionTypeId = styles.get(stylesParams.productPage_infoSectionTypeId);
  const infoSectionColumnNumber = styles.get(stylesParams.productPage_infoSectionColumnNumber);

  const shouldShowZoom = styles.get(stylesParams.productPage_galleryZoom);
  const isFullWidth = styles.get(stylesParams.full_width);

  const navigationPosition = navigationPositionString as GalleryNavigationPosition;
  const navigationType = navigationTypeString as GalleryNavigationType;
  const navigationLocation = navigationLocationString as GalleryNavigationLocation;

  return {
    navigationPosition,
    navigationType,
    navigationLocation,
    imageMode,
    imageRatioId,
    infoSectionTypeId,
    infoSectionColumnNumber,
    shouldShowZoom,
    isFullWidth,
  };
}
